/* Importaciones */

import CONFIGURACION from '../assets/config/configuration.json';
import URLS from '../assets/config/urls.json';

/* Exportaciones por defecto */
export {default as TEXT} from '../assets/data/text.json';
export {default as ERRORS}  from '../assets/data/error.json';

/* ************************************************************************** */
// URLs de las páginas de la web
export const PAGES = URLS.internal;

// Enlaces externos a la web
export const HREF = URLS.external;

// Elemento usado para volver hacia atrás
export const GO_BACK = "←";
